(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["trenwick-sock-buy"] && !Shopify.designMode) return;
  try {
    function initializeSockBuying(root){
 if(root.dataset.initialized)return;
 root.dataset.initialized='true';
 const variants=JSON.parse(root.querySelector('[data-sb-variants]').textContent);
 const form=root.querySelector('form'),hidden=form.querySelector('[data-sb-variant]'),total=root.querySelector('[data-sb-total]'),submit=root.querySelector('[data-sb-submit]');
 const packs=[...form.querySelectorAll('input[type=radio]')],colours=[...root.querySelectorAll('.sb-colours:not(.sb-sizes) input')];
 const sizes=[...root.querySelectorAll('.sb-sizes input')];
 const money=new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD'});
 function update(){
  const colour=colours.find(x=>x.checked).value,size=sizes.find(x=>x.checked).value;
  let selected;
  packs.forEach(input=>{
   const variant=variants.find(v=>v.option1===input.dataset.pack&&v.option2===colour&&v.option3===size);
   input.value=variant.id;input.dataset.price=variant.price;input.dataset.available=String(variant.available);
   if(input.checked)selected=variant;
  });
  document.querySelectorAll('[data-sock-heading-price]').forEach(el=>el.textContent=money.format(selected.price/100)+' AUD');
  document.querySelectorAll('[data-sock-heading-each]').forEach(el=>{const count=parseInt(selected.option1,10);el.textContent=money.format(selected.price/100/count)+' per pair';});
  hidden.value=selected.id;total.textContent=money.format(selected.price/100)+' AUD';
  submit.disabled=!selected.available;submit.textContent=selected.available?submit.dataset.addLabel:submit.dataset.soldLabel;
  const url=new URL(window.location.href);url.searchParams.set('variant',selected.id);history.replaceState({},'',url);
 }
 [...packs,...colours,...sizes].forEach(input=>input.addEventListener('change',update));
}
document.querySelectorAll('[data-sock-buy]').forEach(initializeSockBuying);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sock-buy]').forEach(initializeSockBuying));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trenwick-sock-copy-section"] && !Shopify.designMode) return;
  try {
    function initializeSockCopyVideos(scope) {
  scope.querySelectorAll('[data-tw-copy-video]').forEach(video => {
    if (video.dataset.ready) return;
    video.dataset.ready = 'true';
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    const load = () => {
      const source = video.querySelector('source');
      if (source.dataset.src) {
        source.src = source.dataset.src;
        delete source.dataset.src;
        video.load();
      }
    };
    const play = () => {
      load();
      if (!motion.matches) video.play().catch(() => {});
    };
    video.addEventListener('play', load);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          visible = entry.isIntersecting;
          if (visible) play(); else video.pause();
        }
      }, { threshold: 0.2 });
      observer.observe(video);
    } else load();
    motion.addEventListener('change', () => {
      if (motion.matches) video.pause(); else if (visible) play();
    });
  });
}
initializeSockCopyVideos(document);
document.addEventListener('shopify:section:load', event => initializeSockCopyVideos(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trenwick-sock-sticky"] && !Shopify.designMode) return;
  try {
    function initializeSockSticky(root) {
  const bar = root.querySelector('[data-sock-sticky]');
  if (!bar || bar.dataset.ready) return;
  const form = root.querySelector('.sb-form');
  const mainButton = root.querySelector('[data-sb-submit]');
  const variantInput = root.querySelector('[data-sb-variant]');
  if (!form || !mainButton || !variantInput) return;
  bar.dataset.ready = 'true';
  const variants = JSON.parse(root.querySelector('[data-sb-variants]').textContent);
  const button = bar.querySelector('[data-sticky-submit]');
  const selection = bar.querySelector('[data-sticky-selection]');
  const price = bar.querySelector('[data-sticky-price]');
  const money = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
  function sync() {
    const variant = variants.find(item => String(item.id) === variantInput.value);
    if (!variant) { button.disabled = true; return; }
    selection.textContent = variant.option1 + ' / ' + variant.option2;
    price.textContent = money.format(variant.price / 100);
    button.disabled = mainButton.disabled || !variant.available;
    button.textContent = mainButton.textContent;
    button.setAttribute('aria-busy', mainButton.getAttribute('aria-busy') || 'false');
  }
  function visibility() {
    const rect = mainButton.getBoundingClientRect();
    bar.hidden = rect.bottom > 0;
  }
  button.addEventListener('click', () => {
    sync();
    if (!button.disabled) form.requestSubmit(mainButton);
  });
  bar.querySelector('[data-sticky-change]').addEventListener('click', event => {
    event.preventDefault();
    root.querySelector('.sb-pack-heading').scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    const selected = form.querySelector('input[type="radio"]:checked');
    if (selected) selected.focus({ preventScroll: true });
  });
  root.addEventListener('change', sync);
  const stateObserver = new MutationObserver(sync);
  stateObserver.observe(mainButton, { attributes: true, attributeFilter: ['disabled', 'aria-busy'], childList: true, subtree: true, characterData: true });
  let viewObserver;
  if ('IntersectionObserver' in window) {
    viewObserver = new IntersectionObserver(visibility, { threshold: [0, 1] });
    viewObserver.observe(mainButton);
  } else window.addEventListener('scroll', visibility, { passive: true });
  window.addEventListener('resize', visibility);
  document.body.append(bar);
  sync();
  visibility();
  document.addEventListener('shopify:section:unload', event => {
    if (!event.target.contains(root)) return;
    stateObserver.disconnect();
    if (viewObserver) viewObserver.disconnect();
    window.removeEventListener('scroll', visibility);
    window.removeEventListener('resize', visibility);
    bar.remove();
  });
}
document.querySelectorAll('[data-sock-buy]').forEach(initializeSockSticky);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-sock-buy]').forEach(initializeSockSticky));
  } catch(e) { console.error(e); }
})();

})();
